import { useUIStore } from 'Modules/ui/index.store';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { routeChecks } from 'Utils/routeUtils';

const useVideoSummaryPanel = () => {
  const location = useLocation();
  const { videoSummarySidePanelInfo, resetVideoSummarySidePanel } =
    useUIStore();

  useEffect(() => {
    if (videoSummarySidePanelInfo && !routeChecks.isVideoHistoryDetailsPage()) {
      resetVideoSummarySidePanel();
    }
  }, [
    videoSummarySidePanelInfo,
    resetVideoSummarySidePanel,
    location.pathname,
  ]);

  return {
    isOpen: !!videoSummarySidePanelInfo,
  };
};

export default useVideoSummaryPanel;
